import Router from 'vue-router';
import { routes } from './routes';
import store from '@/store/store';
import { RouteName } from '@/utils/enums';
import { isTokenValid, getUserData } from '@/utils/token';
import { setDefaultHeader } from '@/api/api';

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((routeTo, routeFrom, next) => {
  // Check if auth is required on this route
  // (including nested routes).
  const authRequired = routeTo.matched.some(route => route.meta.authRequired);
  const token = localStorage.getItem('token');

  // Check if we are already logged in.
  if (store.getters['loggedIn']) {
    // Check if the token is valid and not expired, redirect to login if is expired.
    if (token && !isTokenValid(token)) {
      localStorage.removeItem('token');
      return navigate();
    }

    // Don't go to the login page when you are logged in.
    if (routeTo.name === RouteName.LOGIN) {
      if (token != null) {
        setDefaultHeader('Authorization', 'Bearer ' + token);
      }
      return next({ name: RouteName.HOME });
    }

    // Redirect back home is nog authorized
    if (!userIsAuthorized(token)) {
      return next({ name: RouteName.HOME });
    }

    return next();
  }

  // The user is NOT logged in yet, but we do have a token.
  if (token != null) {
    // Check if the token is valid and not expired
    // Redirect to login if is expired.
    if (!isTokenValid(token)) {
      localStorage.removeItem('token');
      return navigate();
    }

    // add the logged in info
    store.commit('SET_USER', getUserData(token));
    setDefaultHeader('Authorization', 'Bearer ' + token);
    return next({ name: RouteName.HOME });
  }

  return navigate();

  function navigate() {
    // If auth isn't required for the route, just continue.
    if (!authRequired) return next();
    // Pass the original route to the login component
    next({ name: RouteName.LOGIN, query: { redirectFrom: routeTo.fullPath } });
  }

  function userIsAuthorized(token: string | null): boolean {
    if (!token) {
      return false;
    }
    const groupMemberships: string[] = getUserData(token).groups;
    return groupMemberships.some(groupMembership => routeTo.meta.authorize.includes(groupMembership));
  }
});

export default router;
